import { useReportContext } from "@/context/ReportContext";
import { PdfUpgradeWrapper } from "@/reports/shared/PdfAddon/PdfUpgradeWrapper";
import type { SxProps } from "@/theme/index";
import { useMoreAction } from "../MoreAction/useMoreAction";
import { ReportActionButton } from "../ReportActionButton/ReportActionButton";

export interface PdfActionProps {
  sx?: SxProps;
  reportPermalink?: string;
  onReportCard?: boolean;
  disableCollapse?: boolean;
}

export const PdfAction: React.FC<PdfActionProps> = ({
  sx,
  reportPermalink,
  onReportCard,
  disableCollapse,
}) => {
  const { permalink: contextPermalink } = useReportContext();
  const permalink = reportPermalink || contextPermalink;
  const { generatePdf, generatingPdf, pdfModalState, setPdfModalState } =
    useMoreAction(permalink);
  const handleGeneratePdf = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    generatePdf();
  };

  return (
    <>
      <ReportActionButton
        collapseText="PDF"
        iconName="PictureAsPdf"
        onClick={handleGeneratePdf}
        sx={sx}
        disabled={generatingPdf}
        onReportCard={onReportCard}
        disableCollapse={disableCollapse}
      />
      <PdfUpgradeWrapper
        modalState={pdfModalState}
        setModalState={setPdfModalState}
        reportPermalink={permalink}
        generatePDF={generatePdf}
      />
    </>
  );
};
